const IconFiles = ({ className }) => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Icon'
                d='M19.6391 10.64V15.32C19.6391 16.1816 20.3376 16.88 21.1991 16.88H25.8791M28.9991 4.39999H18.0788C16.3556 4.39999 14.9588 5.79686 14.9588 7.51998V10.64M28.9991 4.39999H29.8694C30.3087 4.39999 30.7269 4.58503 31.0295 4.90346C31.4844 5.38199 32.2048 6.11878 32.8991 6.73999C33.4433 7.22687 34.2982 8.10063 34.8101 8.63167C35.087 8.91884 35.2391 9.30229 35.2391 9.70118L35.2391 10.64M28.9991 4.39999V9.08C28.9991 9.94156 29.6976 10.64 30.5591 10.64H35.2391M35.2391 10.64L35.2387 26.2401C35.2387 27.9632 33.8418 29.36 32.1187 29.36H25.8786M23.5391 12.98C22.8448 12.3588 22.1244 11.622 21.6695 11.1435C21.3669 10.825 20.9487 10.64 20.5094 10.64H8.71875C6.99563 10.64 5.59876 12.0369 5.59875 13.76L5.59863 32.4799C5.59862 34.203 6.99549 35.5999 8.71862 35.5999L22.7587 35.6C24.4818 35.6 25.8787 34.2032 25.8787 32.4801L25.8791 15.9412C25.8791 15.5423 25.7269 15.1588 25.4501 14.8717C24.9382 14.3406 24.0833 13.4669 23.5391 12.98Z'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconFiles;
